export const darkTheme = {
    bg:"#1C1C27",
    bgLight: "#1C1E27",
    primary:"#854CE6",
    text_primary:"#F2F3F4",
    text_secondary:"#b1b2b3",
    card:"#171721",
    card_light: '#191924',
    button:"#854CE6",
    white:"#FFFFFF",
    black:"#000000",
}

export const lightTheme = {
  bg: "#F7F7FF",              // page background (soft)
  bgLight: "#FFFFFF",         // section bg
  primary: "#7C3AED",         // main brand (lavender)
  secondary: "#06B6D4",       // accent (cyan)
  text_primary: "#0F172A",    // main text
  text_secondary: "#475569",  // secondary text
  card: "#FFFFFF",
  card_light: "#FFFFFF",      // IMPORTANT (Hero uses this)
  border: "#E5E7EB",
  button: "#7C3AED",
  buttonText: "#FFFFFF",
  shadow: "0 12px 30px rgba(15, 23, 42, 0.10)",
  white: "#FFFFFF",
  black: "#000000",
};
